/** Date/time helpers shared by the rituals tab and the agent header. */

export function formatWhen(iso: string | null, timezone: string, locale: string): string | null {
  if (!iso) return null;
  return new Intl.DateTimeFormat(locale === 'en' ? 'en-US' : 'es-AR', {
    timeZone: timezone,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(new Date(iso));
}

/** "America/Argentina/Buenos_Aires" → "Buenos Aires" (the city part, readable). */
export function timezoneCity(timezone: string): string {
  const city = timezone.split('/').pop() ?? timezone;
  return city.replace(/_/g, ' ');
}
